import { memoize } from 'lodash-es';
import { z } from 'zod';

// eslint-disable-next-line no-restricted-imports
/**
 * Runtime config for UI apps that should be attached to the global `window` object (e.g. by an `/app-config.js` script
 * in the HTML) and available when the application starts (similar to boot flags). Unlike boot flags (which are
 * backed by feature flag values), values here usually come from `envconfig` and will only change if the app gets
 * re-deployed.
 */ const getAppConfig = memoize(_getAppConfig);
// Function above uses memoize on this so that we don't repeatedly log errors / do validation on the values every time
// someone asks for them (they shouldn't change once someone loads the app)
function _getAppConfig() {
    try {
        const appConfig = AppConfig.parse(window.chronoAppConfig);
        return appConfig;
    } catch (err) {
        console.error('Failed to get AppConfig from window object, using default values', err);
    }
    // Return default values in case of failure
    return getAppConfigDefaults();
}
/**
 * Get the default values used in case of failure retrieving / validating the actual values. Exported for tests.
 */ function getAppConfigDefaults() {
    return {
        // Use hostname's subdomain by default even though this won't be accurate when, for example, running against a
        // localhost proxy
        tenantNamespace: window.location.hostname.split('.')[0] ?? 'unknown'
    };
}
// Helper schema for strings that can't be empty
const nonEmptyString = z.string().min(1, {
    message: 'String cannot be empty'
});
/**
 * Zod schema for validating the AppConfig object attached to the `window` object.
 */ const AppConfig = z.object({
    tenantNamespace: nonEmptyString
});

export { getAppConfig, getAppConfigDefaults };
//# sourceMappingURL=app-config.js.map
